import axios from "axios";
import { createTransactionID } from "../util";

const win: any = window;
var errorPage = win["errorPageURL"];

const apigeeConfig = {
  api: {
    baseURL: win["apigee_base_api_url"],
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'x-correlation-id': createTransactionID(true),
      'x-channel-id': "PORTAL",
    },
  },
}

export const apigeeApi = axios.create({ ...apigeeConfig.api });

apigeeApi.defaults.validateStatus = function () {
  return true;
};

apigeeApi.interceptors.request.use(
  async (conf: any) => {
    conf.headers["X-Transaction-Id"] = createTransactionID();
    conf.headers["Authorization"] = `Bearer ${win['apigeeToken']}`;
    conf.headers["cem-key"] = win["CEM_KEY"];
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

apigeeApi.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

const createLead = (data: any) => {
  return apigeeApi.post(`${win["apigee_base_api_url"]}/submit-lead/v1/lead-replication`.replace('/api/', '/'), data);
};


export { createLead };
